import { getMeetingTypeListApi, getProductListApi } from '@/api/dataCenter.js';
import { getAreaList } from '@/api/setUp';
export default {
  namespaced: true,
  state: {
    meetingTypeOptions: [], // 会议类型下拉列表
    productList: [], // 会议产品列表
    provinceList: [], // 省数据
  },
  mutations: {
    setMeetingTypeOptions(state, payload) {
      state.meetingTypeOptions = payload;
    },
    setProductList(state, payload) {
      state.productList = payload;
    },
    setProvinceList(state, payload) {
      state.provinceList = payload;
    },
  },
  actions: {
    // 获取会议类型列表
    async getMeetingTypeList({ state, commit }) {
      if (state.meetingTypeOptions.length === 0) {
        await getMeetingTypeListApi()
          .then((res) => {
            if (!res.error) {
              commit(
                'setMeetingTypeOptions',
                res.data.map((item) => ({
                  label: item.name,
                  value: item.value,
                })),
              );
            }
          })
          .catch((error) => {
            this.$message(error.message);
          });
      }
    },
    // 获取产品标签
    async getProductList({ commit }) {
      await getProductListApi()
        .then((res) => {
          if (!res.error) {
            commit(
              'setProductList',
              res.data.map((item) => ({
                label: item.product_name,
                value: item.product_id,
              })),
            );
          }
        })
        .catch((error) => {
          this.$message(error.message);
        });
    },
    // 获取省数据
    async getProvinceData({ state, commit }) {
      if (state.provinceList.length === 0) {
        await getAreaList({
          type: 'Province',
        })
          .then((res) => {
            if (!res.error) {
              commit(
                'setProvinceList',
                res.data.map((item) => ({
                  label: item.area_name,
                  value: item.area_code,
                })),
              );
            }
          })
          .catch((error) => {
            this.$message(error.message);
          });
      }
    },
  },
};
